/******************************************************************************
* This file was generated by ZenStack CLI.
******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { AnyRouter } from '@trpc/server';
import type { CreateTRPCReactOptions } from '@trpc/react-query/shared';
import { type CreateTRPCReact, createTRPCReact as _createTRPCReact } from '@trpc/react-query';
import type { DeepOverrideAtPath } from './utils';
import { ClientType as UserClientType } from "./User.react.type";
import { ClientType as OrganizationClientType } from "./Organization.react.type";
import { ClientType as CompanyClientType } from "./Company.react.type";
import { ClientType as OrganizationMemberClientType } from "./OrganizationMember.react.type";
import { ClientType as SettingsClientType } from "./Settings.react.type";
import { ClientType as AppClientType } from "./App.react.type";
import { ClientType as AppSessionClientType } from "./AppSession.react.type";
import { ClientType as SessionItemClientType } from "./SessionItem.react.type";
import { ClientType as JobClientType } from "./Job.react.type";
import { ClientType as IndexerNodeClientType } from "./IndexerNode.react.type";
import { ClientType as ProviderAccountClientType } from "./ProviderAccount.react.type";
import { ClientType as ProviderAccountScopeClientType } from "./ProviderAccountScope.react.type";
import { ClientType as FormConfigurationClientType } from "./FormConfiguration.react.type";
import { ClientType as ChatParticipantClientType } from "./ChatParticipant.react.type";
import { ClientType as ChatConversationClientType } from "./ChatConversation.react.type";
import { ClientType as ChatMessageClientType } from "./ChatMessage.react.type";
import { ClientType as TaskCommentClientType } from "./TaskComment.react.type";
import { ClientType as TaskClientType } from "./Task.react.type";
import { ClientType as DriveFileClientType } from "./DriveFile.react.type";
import { ClientType as SocialMediaCampaignClientType } from "./SocialMediaCampaign.react.type";
import { ClientType as PostClientType } from "./Post.react.type";
import { ClientType as PwaSubscriptionClientType } from "./PwaSubscription.react.type";
import { ClientType as LeadClientType } from "./Lead.react.type";
import { ClientType as LeadCriteriaClientType } from "./LeadCriteria.react.type";
import { ClientType as UserRuleClientType } from "./UserRule.react.type";
import { ClientType as HistoryItemClientType } from "./HistoryItem.react.type";
import { ClientType as ConversationSummaryClientType } from "./ConversationSummary.react.type";
import { ClientType as AiEmailClientType } from "./AiEmail.react.type";
import { ClientType as AgentEmailStyleClientType } from "./AgentEmailStyle.react.type";
import { ClientType as OrganizationContactClientType } from "./OrganizationContact.react.type";
import { ClientType as SupportTicketClientType } from "./SupportTicket.react.type";
import { ClientType as KnowledgeClientType } from "./Knowledge.react.type";
import { ClientType as OrganizationMetricsClientType } from "./OrganizationMetrics.react.type";
import { ClientType as CallClientType } from "./Call.react.type";

export function createTRPCReact<
    TRouter extends AnyRouter,
    TPath extends string | undefined = undefined,
    TSSRContext = unknown,
    TFlags = null
>(opts?: CreateTRPCReactOptions<TRouter>) {
    const r: CreateTRPCReact<TRouter, TSSRContext, TFlags> = _createTRPCReact<TRouter, TSSRContext, TFlags>(opts);
    return r as DeepOverrideAtPath<CreateTRPCReact<TRouter, TSSRContext, TFlags>, ClientType<TRouter>, TPath>;
}

export interface ClientType<AppRouter extends AnyRouter> {
    user: UserClientType<AppRouter>;
    organization: OrganizationClientType<AppRouter>;
    company: CompanyClientType<AppRouter>;
    organizationMember: OrganizationMemberClientType<AppRouter>;
    settings: SettingsClientType<AppRouter>;
    app: AppClientType<AppRouter>;
    appSession: AppSessionClientType<AppRouter>;
    sessionItem: SessionItemClientType<AppRouter>;
    job: JobClientType<AppRouter>;
    indexerNode: IndexerNodeClientType<AppRouter>;
    providerAccount: ProviderAccountClientType<AppRouter>;
    providerAccountScope: ProviderAccountScopeClientType<AppRouter>;
    formConfiguration: FormConfigurationClientType<AppRouter>;
    chatParticipant: ChatParticipantClientType<AppRouter>;
    chatConversation: ChatConversationClientType<AppRouter>;
    chatMessage: ChatMessageClientType<AppRouter>;
    taskComment: TaskCommentClientType<AppRouter>;
    task: TaskClientType<AppRouter>;
    driveFile: DriveFileClientType<AppRouter>;
    socialMediaCampaign: SocialMediaCampaignClientType<AppRouter>;
    post: PostClientType<AppRouter>;
    pwaSubscription: PwaSubscriptionClientType<AppRouter>;
    lead: LeadClientType<AppRouter>;
    leadCriteria: LeadCriteriaClientType<AppRouter>;
    userRule: UserRuleClientType<AppRouter>;
    historyItem: HistoryItemClientType<AppRouter>;
    conversationSummary: ConversationSummaryClientType<AppRouter>;
    aiEmail: AiEmailClientType<AppRouter>;
    agentEmailStyle: AgentEmailStyleClientType<AppRouter>;
    organizationContact: OrganizationContactClientType<AppRouter>;
    supportTicket: SupportTicketClientType<AppRouter>;
    knowledge: KnowledgeClientType<AppRouter>;
    organizationMetrics: OrganizationMetricsClientType<AppRouter>;
    call: CallClientType<AppRouter>;
}
